import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';
import * as LucideIcons from 'lucide-react';
import { services } from '../data/mock';
import { Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { companyInfo } from '../data/mock';

const Services = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Hizmetlerimiz"
        description="Halı yıkama, koltuk temizleme, stor perde ve yorgan yıkama hizmetleri. Bahçeşehir, Beylikdüzü, Esenyurt, Başakşehir ve Büyükçekmece'de ücretsiz servis."
        keywords="halı yıkama hizmeti, koltuk temizleme, yerinde koltuk yıkama, yorgan yıkama, stor perde temizleme, profesyonel halı yıkama"
        canonical="https://www.bahcesehirduruhaliyikama.com/hizmetler"
      />
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Hizmetlerimiz</h1>
          <p className="text-xl text-teal-50 max-w-3xl mx-auto">
            Ev tekstilleriniz için profesyonel bakım ve temizlik hizmetleri. 
            Modern ekipman ve çevre dostu ürünlerle hizmetinizdeyiz.
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="space-y-12">
            {services.map((service, index) => {
              const Icon = LucideIcons[service.icon] || LucideIcons.Sparkles;
              const isEven = index % 2 === 0;
              
              return (
                <div key={service.id} className={`grid lg:grid-cols-2 gap-8 items-center ${isEven ? '' : 'lg:flex-row-reverse'}`}>
                  <div className={`${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                    <div className="relative rounded-2xl overflow-hidden shadow-xl h-96">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
                    </div>
                  </div>
                  <div className={`${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
                    <Card className="p-8 border-2 border-teal-100 shadow-lg">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                          <Icon className="w-7 h-7 text-teal-600" />
                        </div>
                        <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
                      </div>
                      <p className="text-gray-700 text-lg mb-6 leading-relaxed">{service.description}</p>
                      <div className="space-y-3">
                        <h3 className="font-semibold text-gray-900 text-lg">Hizmet Özellikleri:</h3>
                        <ul className="grid grid-cols-2 gap-3">
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="flex items-center text-gray-700">
                              <LucideIcons.CheckCircle className="w-5 h-5 text-teal-600 mr-2 flex-shrink-0" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Card>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Çalışma Sürecimiz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Kolay ve hızlı süreç ile halılarınız tertemiz
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { step: '1', title: 'İletişim', desc: 'Bizi arayın veya online form doldurun', icon: 'Phone' },
              { step: '2', title: 'Ücretsiz Alım', desc: 'Halılarınızı adresinizden ücretsiz alıyoruz', icon: 'Truck' },
              { step: '3', title: 'Profesyonel Yıkama', desc: 'Modern tesisimizde özenle yıkıyoruz', icon: 'Droplets' },
              { step: '4', title: 'Teslim', desc: '2-3 gün içinde tertemiz teslim ediyoruz', icon: 'Package' }
            ].map((item) => {
              const Icon = LucideIcons[item.icon];
              return (
                <Card key={item.step} className="text-center p-6 border-2 hover:border-teal-500 transition-colors">
                  <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                    {item.step}
                  </div>
                  <Icon className="w-10 h-10 text-teal-600 mx-auto mb-3" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.desc}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Hemen Hizmet Alın</h2>
          <p className="text-xl mb-8 text-teal-50 max-w-2xl mx-auto">
            Profesyonel temizlik hizmetimizden yararlanmak için hemen iletişime geçin!
          </p>
          <a href={`tel:${companyInfo.phones[0]}`}>
            <Button size="lg" className="bg-white text-teal-600 hover:bg-gray-100 text-lg px-8 py-6 rounded-xl">
              <Phone className="w-5 h-5 mr-2" />
              {companyInfo.phones[0]}
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
